import React from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { ConfigProvider, Typography } from 'antd';
import OwlLogo from '../../assets/app-spinner.svg';
import { Locale } from '../../context/AppProvider';
import { getThemeConfig } from '../../context/theme';
import type { StoreState } from '../../data/store';

import styles from './ErrorContainer.module.scss';

export enum ErrorType {
  MissingTenantId = 'missing_tenant_id',
}

const DEFAULT_MESSAGE =
  "Something's gone wrong! Please contact your administrator.";

const ErrorContainer: React.FC = () => {
  const { state } = useLocation();
  const { messages } = React.useContext(Locale);
  const darkMode = useSelector((s: StoreState) => s['session'].darkMode);
  const themeConfig = React.useMemo(() => getThemeConfig(darkMode), [darkMode]);

  const errorMessage = React.useMemo(() => {
    if (!state?.error) {
      return messages['platform.errors.default'] ?? DEFAULT_MESSAGE;
    }

    return (
      messages[`platform.errors.${state?.error}`] ??
      messages['platform.errors.default'] ??
      DEFAULT_MESSAGE
    );
  }, [state?.error, messages]);

  return (
    <ConfigProvider theme={themeConfig}>
      <div className="app-spinner">
        <OwlLogo className={styles.owlLogo} />
      </div>
      <Typography.Text type="secondary" className={styles.description}>
        {errorMessage}
      </Typography.Text>
    </ConfigProvider>
  );
};

export default ErrorContainer;
